<template>
    <modal ref="modal" size="modal-lg" :modal-scrollable="modalScrollable">
        <template #body>
            <steps :item="item" :items="steps" @cancel="close">
                <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
                    <slot :key="slot" :name="slot" :item="item" v-bind="scope" />
                </template>
            </steps>
        </template>
    </modal>
</template>
<script>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref } from 'vue';
import Modal from '@/Shared/Modal'
import TextInput from '@/Shared/TextInput'
import SwitchInput from '@/Shared/SwitchInput'
import LoadingButton from '@/Shared/LoadingButton'
import Steps from '@/Shared/Steps/Steps'

export default {
    components: {
        Modal,
        TextInput,
        SwitchInput,
        LoadingButton,
        Steps,
    },
    props: {
        title: String,
        url: String,
        multipart: {
            type: Boolean,
            default: false
        },
        processing: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: {
                errors: {}
            }
        },
        modalScrollable: {
            type: Boolean,
            default: false,
        },
        steps: {
            type: Object,
            default: {}
        },
    },
    setup(props, context) {
        const item = ref(props.item);
        const processing = ref(props.processing);

        const modal = ref(null);
        
        const openModalEdit = (i) => {
            processing.value = false;
            item.value = useForm(i);
            modal.value.showModal = true;
        }

        const closeModalEdit = () => {
            modal.value.showModal = false;
        }

        return {
            openModalEdit,
            closeModalEdit,
            modal,
            item,
            processing
        }
    },
    methods: {
        open() {
            this.$refs.modal.showModal = true;
        },
        close() {
            this.$refs.modal.showModal = false;
        },
    },
}
</script>
<style>
    
</style>